<template>
  <div class="dataWrapper">
    <header>
      <!-- 面包屑 -->
      <a-breadcrumb>
        <a-breadcrumb-item>
          <router-link to="/deviceList">设备列表</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>查看数据</a-breadcrumb-item>
      </a-breadcrumb>
      <h2 class="dataHeadTitle">{{sbJson.name}}</h2>
    </header>

    <section>
      <GetTable :sbJson="sbJson" />
    </section>

  </div>
</template>

<script>
import GetTable from '@/components/deviceList/deviceDetail.vue'
export default {
  data () {
    return {
    }
  },
  created () {
  },
  computed: {
    sbJson: function () {
      return JSON.parse(this.$route.query.param)
    }
  },
  components: {
    GetTable
  }
}
</script>

<style lang='less' scoped>
.dataWrapper {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  header {
    height: 0.98rem;
    padding: 0.16rem 0.32rem;
    background-color: #fff;

    .dataHeadTitle {
      font-size: 0.2rem;
      color: #405891;
      padding-top: 0.16rem;
      margin: 0;
      font-weight: bold;
    }
  }

  section {
    height: calc(100% - 0.98rem);
    overflow: auto;
  }
}
</style>
